<style lang="less" rel="stylesheet/less" scoped>
.playvideo {
  width: 100%;
  height: 100%;
  vertical-align: bottom;
  video {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
  }
}
</style>
<template>
  <div class="playvideo" id="playvideo">
    <video
      name="playvideocon"
      class="playvideocon"
      ref="video"
      :poster="posterUrl"
      @contextmenu.prevent
    >
      Your browser is too old which doesn't support HTML5 video.
    </video>
  </div>
</template>
<script>
import utils from "utils";
import formatSeiMessage from "../../../js/seiUtils";
import { mapState, mapMutations } from "vuex";
import common from "common";
export default {
  data() {
    return {
      reconnectionNum: 0,
      isFollow: false,
      isFollowInterval: null,
      posterUrl: "",
      test_use_sei: true,
      waitingInterval: null,
      uuids: [],
      timer: null,
      videoLoadTimeoutInterval: null,
      waitingNumData: [],
      uniqueId: "",
      uniqueTaskId: "",
    };
  },
  props: {
    aiSwitchVideoUrl: {
      default: false,
      type: Boolean,
      required: true,
    },
  },
  created() {
    this.eventHub();
  },
  mounted() {
    this.$nextTick(this.creatPlayer);
    this.$root.eventHub.$emit("createLog", {
      id: "LMTrackEventStreamChange",
      data: {
        unique_id: "",
        name: common.get("liveVideoUrlData").live_video_url_stream,
        url: common.get("liveVideoUrlData").live_video_url,
        reffer: "",
      },
    });
  },
  computed: {
    ...mapState([
      "liveVideoUrlData",
      "video_stream_load_timeout",
      "video_freeze_time",
      "video_freeze_last",
    ]),
  },
  methods: {
    ...mapMutations(["updateSeiTime"]),
    //视频加载超时时间
    videoLoadTimeout() {
      clearTimeout(this.videoLoadTimeoutInterval);
      this.videoLoadTimeoutInterval = setTimeout(() => {
        this.destroyVideo();
        this.$emit("loaderr");
      }, this.video_stream_load_timeout * 1000);
    },
    eventHub() {
      this.offEventHub();
      this.$root.eventHub.$on("restartVideo", () => {
        this.reconnection();
      });
      this.$root.eventHub.$on("firstPlayVideo", () => {
        this.$refs.video.play();
      });
      this.$root.eventHub.$on("destroyVideo", () => {
        this.destroyVideo();
      });
      this.$root.eventHub.$on("videoMuted", (muted) => {
        this.$refs.video.muted = muted;
      });
      this.$root.eventHub.$on("test_use_sei", (flag) => {
        this.test_use_sei = flag;
      });
    },
    offEventHub() {
      this.$root.eventHub.$off("restartVideo");
      this.$root.eventHub.$off("videoMuted");
      this.$root.eventHub.$off("firstPlayVideo");
      this.$root.eventHub.$off("destroyVideo");
      this.$root.eventHub.$off("test_use_sei");
    },
    removeEventListener() {
      let element = this.$refs.video;
      if (!element) return;
      element.removeEventListener("loadeddata", this.videoLoadeddata);
      element.removeEventListener("playing", this.videoPlaying);
      element.removeEventListener("waiting", this.videoWaiting);
    },
    videoLoadeddata() {
      //
      this.posterUrl = "";
      this.player.play();
      this.$emit("tip", false);
      this.reconnectionNum = 0;
      if (this.$refs.video.paused) {
        this.$emit("firstPlay");
        //
      }
      this.isFollow = false;
      this.follow();
      clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.$root.eventHub.$emit("createLog", {
          id: "LMTrackEventLiveStreamInfo",
          data: {
            bitRate:
              this.player &&
              this.player._transmuxer._controller._ioctl.currentSpeed,
            liveServer: "", //
            clientIP: common.WANIP, //客户端ip
          },
        });
      }, 60 * 1000);
    },
    videoPlaying() {
      //

      this.posterUrl = "";
      clearTimeout(this.waitingInterval);
      clearTimeout(this.videoLoadTimeoutInterval);
      this.$emit("tip", false);
      this.reconnectionNum = 0;
    },
    getCurrentTime() {
      return this.$refs.video.currentTime;
    },
    waitingNum() {
      if (!this.aiSwitchVideoUrl) {
        //
        this.waitingNumData = [];
        return;
      }
      this.waitingNumData.unshift(Date.now());
      this.waitingNumData.length = this.video_freeze_time;
      let lastTime = this.waitingNumData[0];
      let firstTime = this.waitingNumData[this.video_freeze_time - 1] || 0;
      if (lastTime - firstTime < this.video_freeze_last * 1000) {
        this.waitingNumData = [];
        this.$emit("autoSwitchVideoUrl");
      }
      // console.log(this.waitingNumData)
    },
    videoWaiting() {
      if (this.isFollow) {
        clearTimeout(this.waitingInterval);
        //卡顿时间超过3s抛出事件
        this.waitingInterval = setTimeout(() => {
          this.waitingNum();

          //this.$emit("tip", true);
          this.$root.eventHub.$emit("createLog", {
            id: "LMTrackEventStreamCaton",
            data: {
              url: this.liveVideoUrlData.live_video_url,
              cdnIP: "",
            },
          });
        }, 3000);
      }
    },
    creatPlayer() {
      let uri = this.liveVideoUrlData.live_video_url;
      common.set("live_video_url_now", uri);
      if (!uri) {
        this.$emit("loaderr");
        return;
      }
      this.$emit("tip", true);
      let element = this.$refs.video;
      this.destroyVideo();
      this.videoLoadTimeout();
      this.player = flvjs.createPlayer(
        {
          type: "flv",
          url: uri,
        },
        {
          enableWorker: false,
          lazyLoadMaxDuration: 3 * 60,
          seekType: "range",
          enableStashBuffer: false,
          reconnection: this.reconnectionCallback,
          seekFollow: this.follow,
          seiFun: this.seiCallback,
          fixAudioTimestampGap: false,
        }
      );
      this.player.attachMediaElement(element);
      // 视频地址加载出错：视频地址不正确、断流、自己断网
      this.player.on("error", () => {
        this.reconnectionNum++;
        if (this.reconnectionNum >= 3) {
          clearTimeout(this.videoLoadTimeoutInterval);
          this.$emit("loaderr");
          this.$root.eventHub.$emit("createLog", {
            id: "LMTrackEventStreamLose",
            data: {
              url: this.liveVideoUrlData.live_video_url,
              cdnIP: "",
            },
          });
          this.reconnectionNum = 0;
          this.destroyVideo();
          return;
        }
        this.$emit("tip", true);
        this.reconnection();
      });
      this.player.load();
      this.player.on("statistics_info", (e) => {
        this.$emit("videoSpeed", e.speed);
        //
      });
      this.removeEventListener();
      element.addEventListener("loadeddata", this.videoLoadeddata);
      //在媒体开始播放时触发（不论是初次播放、在暂停后恢复、或是在结束后重新开始）。
      element.addEventListener("playing", this.videoPlaying);
      //在一个待执行的操作（如回放）因等待另一个操作（如跳跃或下载）被延迟时触发。
      element.addEventListener("waiting", this.videoWaiting);
    },
    seiCallback(status, res) {
      if (this.test_use_sei === false) {
        //
        return;
      }
      this.updateSeiTime(Date.now());
      formatSeiMessage(status, res, (datas, flag) => {
        if (flag) {
          if (!this.uuids.includes(datas.unique_id)) {
            this.$root.eventHub.$emit("partCoin", datas.unique_id);
            this.uuids.unshift(datas.unique_id);
            this.uuids.length = 30;
          }
          return;
        }

        this.$root.eventHub.$emit("seiMessage", JSON.stringify(datas));
      });
      console.log(
        "res-----",
        res.data.task && res.data.task.map((v) => v.type)
      );
      if (res.data && res.data.task) {
        let cameraSizeData = res.data.task.filter((v) => {
          return v.type === "camera_size";
        })[0];
        let handleUpShowData = res.data.task.filter((v) => {
          return v.type === "hand_up_show";
        })[0];
        let sendTaskData = res.data.task.filter((v) => {
          return v.type === "teacher_send_task";
        })[0];

        cameraSizeData &&
          this.$root.eventHub.$emit("cameraSize", cameraSizeData);
        if (handleUpShowData && this.uniqueId !== handleUpShowData.unique_id) {
          this.uniqueId = handleUpShowData.unique_id;
          handleUpShowData &&
            this.$root.eventHub.$emit("requestHandup", handleUpShowData);
        }
        if (sendTaskData && this.uniqueTaskId !== sendTaskData.unique_id) {
          this.uniqueTaskId = sendTaskData.unique_id;
          sendTaskData &&
            this.$root.eventHub.$emit(
              "seiMessage",
              JSON.stringify(sendTaskData)
            );
        }
      }
    },
    reconnectionCallback() {
      this.reconnection(true);
    },
    reconnection(flag) {
      this.posterUrl = flag ? utils.screenshotsVideo() : "";
      this.creatPlayer();
      this.$root.eventHub.$emit("createLog", {
        id: "LMTrackEventPlayerRestart",
      });
    },
    follow() {
      clearTimeout(this.isFollowInterval);
      this.isFollowInterval = setTimeout(() => {
        this.isFollow = true;
      }, 5000);
      this.player.currentTime = this.player.buffered.end(0) - 0.2;
    },
    destroyVideo() {
      if (typeof this.player !== "undefined") {
        if (this.player != null) {
          this.player.die();
          this.player = null;
        }
      }
      this.removeEventListener();
      clearInterval(this.timer);
    },
  },
  beforeDestroy() {
    this.destroyVideo();
    this.offEventHub();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/bussiness/video/ccplayer.vue